// Simple SVG icons for commodities - these can be replaced with proper images later
const goldSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23FFD700' stroke='%23DAA520' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='16' fill='%23B8860B'%3EAU%3C/text%3E%3C/svg%3E";

const silverSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23C0C0C0' stroke='%23A0A0A0' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='16' fill='%23808080'%3EAG%3C/text%3E%3C/svg%3E";

const oilSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23000000' stroke='%23333333' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='14' fill='%23FFFFFF'%3EOIL%3C/text%3E%3C/svg%3E";

const gasSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%234169E1' stroke='%233050C0' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='14' fill='%23FFFFFF'%3EGAS%3C/text%3E%3C/svg%3E";

const wheatSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23DEB887' stroke='%23CD853F' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='12' fill='%238B4513'%3EWHT%3C/text%3E%3C/svg%3E";

const copperSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23B87333' stroke='%23A0522D' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='16' fill='%23654321'%3ECU%3C/text%3E%3C/svg%3E";

const cornSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%23FFD700' stroke='%23DAA520' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='12' fill='%23B8860B'%3ECRN%3C/text%3E%3C/svg%3E";

const coffeeSVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='40' fill='%236F4E37' stroke='%235D4037' stroke-width='3'/%3E%3Ctext x='50' y='55' text-anchor='middle' font-size='12' fill='%23FFFFFF'%3ECFE%3C/text%3E%3C/svg%3E";

export const commodities = [
  {
    id: 1,
    name: "Gold",
    symbol: "XAU",
    img: goldSVG,
    description: "Precious metal hedge against inflation",
    apr: "8.5%",
  },
  {
    id: 2,
    name: "Silver",
    symbol: "XAG",
    img: silverSVG,
    description: "Industrial and precious metal",
    apr: "7.2%",
  },
  {
    id: 3,
    name: "Crude Oil",
    symbol: "WTI",
    img: oilSVG,
    description: "West Texas Intermediate",
    apr: "12.1%",
  },
  {
    id: 4,
    name: "Natural Gas",
    symbol: "NG",
    img: gasSVG,
    description: "Clean energy commodity",
    apr: "15.3%",
  },
  {
    id: 5,
    name: "Wheat",
    symbol: "WHT",
    img: wheatSVG,
    description: "Essential agricultural commodity",
    apr: "9.8%",
  },
  {
    id: 6,
    name: "Copper",
    symbol: "HG",
    img: copperSVG,
    description: "Industrial metal for infrastructure",
    apr: "10.4%",
  },
  {
    id: 7,
    name: "Corn",
    symbol: "ZC",
    img: cornSVG,
    description: "Staple agricultural product",
    apr: "8.9%",
  },
  {
    id: 8,
    name: "Coffee",
    symbol: "KC",
    img: coffeeSVG,
    description: "Global beverage commodity",
    apr: "11.7%",
  },
];
